import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, map } from 'rxjs';
import { AppConfigService } from '../providers/config.service';
import { ObservableDataLoaderService } from './observable-data-loader.service';

export interface TenantStats {
  total_assets_original_size_including_subgalleries: bigint;
  total_assets_version_size_including_subgalleries: bigint;
  total_assets_original_number_including_subgalleries: number;
}
export interface GalleryStats {
  total_assets_original_size_including_subgalleries: bigint;
  total_assets_version_size_including_subgalleries: bigint;
}

@Injectable({
  providedIn: 'root',
})
export class StatsService {
  private config = inject(AppConfigService);
  private http = inject(HttpClient);
  private loader = inject(ObservableDataLoaderService);
  private readonly tenantStatsSubject = new BehaviorSubject<TenantStats>(undefined);

  public getTenantStats() {
    this.loadTenantStats();
    return this.tenantStatsSubject;
  }

  private loadTenantStats() {
    this.http.get<TenantStats>(`${this.config.apiEndpoint}/overview`).subscribe(resp => {
      resp.total_assets_original_size_including_subgalleries = BigInt(
        resp.total_assets_original_size_including_subgalleries
      );
      resp.total_assets_version_size_including_subgalleries = BigInt(
        resp.total_assets_version_size_including_subgalleries
      );
      this.tenantStatsSubject.next(resp);
    });
  }

  public getGalleryStats(galleryId: string) {
    return this.loader.get(`gallery-stats-${galleryId}`, () => {
      return this.http
        .get<GalleryStats>(`${this.config.apiEndpoint}/galleries/${galleryId}/overview?ignore_errors`)
        .pipe(
          map(resp => {
            return {
              total_assets_original_size_including_subgalleries: BigInt(
                resp.total_assets_original_size_including_subgalleries
              ),
              total_assets_version_size_including_subgalleries: BigInt(
                resp.total_assets_version_size_including_subgalleries
              ),
            };
          })
        );
    });
  }

  public reloadAllGalleryStats() {
    this.loader.removeFuzzy('gallery-stats-');
  }
}
